import { render, staticRenderFns } from "./appMultilineTextLink.vue?vue&type=template&id=1379d118&"
import script from "./appMultilineTextLink.vue?vue&type=script&lang=js&"
export * from "./appMultilineTextLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports